import React, { useEffect } from 'react';
import { Box, Container, Paper, Typography, Divider } from '@mui/material';
import { TokenResponse } from '@react-oauth/google';

import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { useUser } from '../../context/UserContext';

const RefundPolicyPage = () => {
    const { login, isLoading } = useUser();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleSuccess = async (tokenResponse: TokenResponse) => {
        try {
            await login(tokenResponse);
        } catch (loginError) {
            console.error(loginError);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: (theme) =>
                    `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Header onLoginSuccess={handleSuccess} isLoading={isLoading} />

            <Container component="main" maxWidth="md" sx={{ flexGrow: 1, py: 4 }}>
                <Paper sx={{ p: { xs: 3, md: 5 } }}>
                    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'primary.main' }}>
                        Refund Policy
                    </Typography>
                    <Divider sx={{ my: 2 }} />

                    <Typography paragraph>
                        At Ecom (ISN Group d.o.o.), we sell digital credits that allow access to AI generation tools. Due to the nature of digital content and immediate access to the service, our refund policy is as follows:
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        EU Right of Withdrawal (Waiver)
                    </Typography>
                    <Typography paragraph>
                        If you are a consumer based in the European Union, you normally have the right to withdraw from a contract within 14 days. However, by purchasing Credits on Ecom, <strong>you expressly consent to the immediate performance of the contract</strong> (immediate provision of credits) and <strong>you acknowledge that you thereby lose your right of withdrawal</strong> once the digital content/service has been provided.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Non-Refundable Circumstances
                    </Typography>
                    <Typography paragraph>
                        Refunds are generally <strong>not provided</strong> for:
                    </Typography>
                    <ul>
                        <li>Change of mind after purchasing credits.</li>
                        <li>Dissatisfaction with specific AI-generated results (users are encouraged to use the free trial credits to evaluate quality before purchasing).</li>
                        <li>Unused credits remaining in your account.</li>
                    </ul>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Exceptions
                    </Typography>
                    <Typography paragraph>
                        We may, at our sole discretion, offer a refund if:
                    </Typography>
                    <ul>
                        <li>There was a technical error that prevented the credits from being added to your account.</li>
                        <li>The service was completely unavailable for an extended period due to our technical failure.</li>
                    </ul>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        How to Request a Refund
                    </Typography>
                    <Typography paragraph>
                        If you believe you are entitled to a refund due to a technical error, please contact us at <strong>support@ecom.time2future.com</strong> with your transaction ID and a description of the issue.
                    </Typography>

                </Paper>
            </Container>

            <Footer />
        </Box>
    );
};

export default RefundPolicyPage;
